module.exports = __webpack_public_path__ + "img/icon-stock-po.b1059c65.png";